import { type UseMutationOptions, type UseMutationResult, useMutation } from '@tanstack/react-query';

import { useQueryStateAppContext } from '@/packages/query-state/shared/context/appContext';

import {
  type TAddOfferToComparisonRequest,
  type TAddOfferToComparisonResponse_1,
} from '@/repositories/generated/shared/offers-comparison/v2/add-offer-to-comparison';

import { type QueryError, getQueryKey } from './internal/config';
import { fetchAddToComparisonService } from './internal/fetchService';

export function useAddComparisonMutation<TContext = unknown>(
  options?: Omit<
    UseMutationOptions<TAddOfferToComparisonResponse_1, QueryError, TAddOfferToComparisonRequest, TContext>,
    'mutationKey' | 'mutationFn'
  >,
): UseMutationResult<TAddOfferToComparisonResponse_1, QueryError, TAddOfferToComparisonRequest, TContext> {
  const context = useQueryStateAppContext();

  return useMutation<TAddOfferToComparisonResponse_1, QueryError, TAddOfferToComparisonRequest, TContext>({
    mutationFn: parameters => fetchAddToComparisonService(context, parameters),
    mutationKey: getQueryKey(),
    ...options,
  });
}
